// Extracted from frozen iOS58 ContactScreen; see docs/contact-20261009/generate-reference.cjs.
const PHONE_PREFIXES = [
  '010',
  '070',
  '02',
  '031',
  '032',
  '055',
  '051',
  '053',
  '054',
  '041',
  '061',
  '063',
  '062',
  '033',
  '043',
  '042',
  '052',
  '064',
  '044',
];
const ATTACHMENT_COUNT_LIMIT = 3;
const ATTACHMENT_FILE_LIMIT = 5 * 1024 * 1024;
const ATTACHMENT_TOTAL_LIMIT = 10 * 1024 * 1024;
const fileSizeLabel = (size) => {
  if (!size) return '';
  if (size < 1024 * 1024) return `${Math.max(1, Math.round(size / 1024))}KB`;
  return `${(size / (1024 * 1024)).toFixed(1)}MB`;
};
const albumCorrectionMessage = (params, t) => {
  if (params?.kind !== 'albumCorrection') return '';
  const albumLabel = [params.artistName, params.albumTitle].filter(Boolean).join(' - ');
  const albumUrl = params.albumPath ? `https://postpop.kr/reviews/${params.albumPath}` : '';
  return [
    t('contact.correctionSubject'),
    albumLabel ? t('contact.correctionAlbum', { album: albumLabel }) : '',
    albumUrl ? `URL: ${albumUrl}` : '',
    '',
    t('contact.correctionField'),
    '',
    t('contact.correctionContent'),
    '',
    t('contact.correctionSource'),
  ]
    .filter((line, index, lines) => line || (index > 0 && lines[index - 1]))
    .join('\n');
};

export {
  PHONE_PREFIXES,
  ATTACHMENT_COUNT_LIMIT,
  ATTACHMENT_FILE_LIMIT,
  ATTACHMENT_TOTAL_LIMIT,
  fileSizeLabel,
  albumCorrectionMessage,
};
